// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"02e27d8a","732":"f9aa3f51","977":"051b8d1e"}[chunkId] + ".chunk.js";
};